import { render, staticRenderFns } from "./HotVideoDetail.vue?vue&type=template&id=cd705afa&scoped=true"
import script from "./HotVideoDetail.vue?vue&type=script&lang=js"
export * from "./HotVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./HotVideoDetail.vue?vue&type=style&index=0&id=cd705afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd705afa",
  null
  
)

export default component.exports